import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { USE_CASE_HEADER_COLORS } from '../../constants/useCaseColors';

interface AnimatedInsuranceLinkProps {
  href: string;
  label: string;
  className?: string;
  onClick?: () => void;
}

const AnimatedInsuranceLink: React.FC<AnimatedInsuranceLinkProps> = ({
  href,
  label,
  className = '',
  onClick,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const color = USE_CASE_HEADER_COLORS[currentIndex];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % USE_CASE_HEADER_COLORS.length);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      animate={{
        backgroundColor: `${color}30`,
        color,
      }}
      transition={{ duration: 0.5 }}
      className={`inline-block px-3 py-1.5 rounded-md font-bold transition-shadow hover:shadow-sm ${className}`}
    >
      {label}
    </motion.a>
  );
};

export default AnimatedInsuranceLink;
